<template>
  <div>
    <div>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
                <b-form-invalid-feedback id="inputFeedback">
                  {{ $t('Select accounting period') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select :options="listOfChargePolicy" v-model="periodicService.policy_id"/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :disabled="isEdit && periodicService.scheme_id > 0" :options="listOfCoefficientScheme" v-model="periodicService.scheme_id"  @change="coeffSchemeChanged"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :disabled="periodicService.scheme_id > 0" type="number" v-model="periodicService.cost_coef"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="periodicService.charged_in_curr_period" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderStartDate"
              :isDisabled="isEdit"
              @onDateChanged="(unixDate) => {periodicService.start_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(periodicService.start_date ? periodicService.start_date : new Date()/1000 ).toDate())}"
              />
            </b-form-group>
            <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderExpireDate"
              :isDisabled="infinityDate"
              @onDateChanged="(unixDate) => {periodicService.expire_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(periodicService.expire_date ? periodicService.expire_date : new Date()/1000 ).toDate())}"
              />
              <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                <b-input-group-append>
                  <b-button variant="secondary" size="sm" @click="clearHouse">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-textarea type="text" v-model="periodicService.house_comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-textarea type="text" v-model="periodicService.comment"/>
            </b-form-group>
          </b-col>
        </b-tab>
      </b-tabs>
    </div>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" size="lg"/>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="periodicService.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="periodicService.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg">
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'
export default {
  components: {
    FormHouse,
    FormAccountinfPeriod,
    FormChargePolicies,
    FormCharged
  },
  props: {
    listOfCoefficientScheme: null,
    listOfChargePolicy: null,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0,
    accountingPeriodId: 0
  },
  data () {
    return {
      periodicServiceEdit: null,
      rerenderStartDate: 0,
      rerenderExpireDate: 0,
      periodicService: {
        'house_comment': '',
        'charged_in_curr_period': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        // new Date().getTime() = local time with TZ
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'cost_coef': 100,
        'slink_id': 0,
        'scheme_id': 0
      },
      infinityDate: true,
      currentChargePolicy: null
    }
  },
  methods: {
    async saveServiceLink () {
      if (!this.periodicService.accounting_period_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      let tmpPeriodicService = JSON.parse(JSON.stringify(this.periodicService))
      tmpPeriodicService.cost_coef = tmpPeriodicService.cost_coef / 100
      tmpPeriodicService.expire_date = this.infinityDate ? 2000000000 : tmpPeriodicService.expire_date
      tmpPeriodicService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
      if (this.isEdit) {
        tmpPeriodicService.slink_id = this.currentService.service_link_id
      } else {
        tmpPeriodicService.account_id = this.selectedAccount
        tmpPeriodicService.service_id = this.currentService.service_id
        tmpPeriodicService.user_id = this.currentUser.user_id
      }
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_PERIODIC_SERVICE_LINK', tmpPeriodicService)
        : this.$store.dispatch('Users/CREATE_PERIODIC_SERVICE_LINK', tmpPeriodicService)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          let newSlinkId = response.data.service_link_id ? response.data.service_link_id : this.currentService.service_link_id
          this.addCoefSchemeToSlink(newSlinkId)
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
          this.hideSelectService()
          this.$root.$emit('makeToasts')
        }
      })
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormChargePolicies () {
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        if (this.periodicService.policy_id === el.policy_id) {
          this.currentChargePolicy = JSON.parse(JSON.stringify(el))
          this.$refs.detailChargePolicies.show()
        }
      }
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    clearHouse () {
      this.periodicService.house_id = 0
    },
    coeffSchemeChanged (schemeId) {
      if (schemeId === 0) {
        this.periodicService.cost_coef = 100
      } else {
        let newCostCoef = 100
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === schemeId) {
            for (let elIt of el.items) {
              if (elIt.delay === 0) {
                newCostCoef = elIt.coeff * 100
                break
              }
            }
            break
          }
        }
        this.periodicService.cost_coef = Math.round(newCostCoef)
      }
    },
    addCoefSchemeToSlink (newSlinkId) {
      if ((!this.isEdit && this.periodicService.scheme_id > 0) ||
     (this.periodicServiceEdit !== null &&
     this.periodicServiceEdit.coefficientschedulelink === undefined &&
     this.periodicService.scheme_id > 0)) {
        let coefSchedule = {items: []}
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === this.periodicService.scheme_id) {
            coefSchedule.items = el.items
          }
        }
        let responseCoefScheduleId = this.$store.dispatch('Users/CREATE_COEFFICIENT_SCHEDLE', coefSchedule)
        responseCoefScheduleId.then(responseCoefScheduleId => {
          let newCoefScheduleId = responseCoefScheduleId.data.coefficient_schedule_id
          let schedule = {
            scheme_id: this.periodicService.scheme_id,
            slink_id: Number(newSlinkId),
            schedule_id: Number(newCoefScheduleId),
            change_policy: 0
          }
          this.$store.dispatch('Users/CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE', schedule)
        })
      }
    }
  },
  mounted () {
    this.periodicService.scheme_id = this.currentService.scheme_id
    this.coeffSchemeChanged(this.currentService.scheme_id)
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_PERIODIC_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.periodicServiceEdit = this.$store.getters['Users/PERIODIC_SERVICE_LINK']
        this.periodicService.start_date = this.periodicServiceEdit.periodicservicelink.start_date
        this.periodicService.expire_date = this.periodicServiceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
        this.infinityDate = this.periodicServiceEdit.periodicservicelink.expire_date === 2000000000
        this.periodicService.cost_coef = this.periodicServiceEdit.periodicservicelink.cost_coef * 100
        this.periodicService.comment = this.periodicServiceEdit.periodicservicelink.comment
        this.periodicService.accounting_period_id = this.periodicServiceEdit.periodicservicelink.accounting_period_id
        this.periodicService.house_id = this.periodicServiceEdit.periodicservicelink.house_id
        this.periodicService.policy_id = this.periodicServiceEdit.periodicservicelink.policy_id
        this.periodicService.house_comment = this.periodicServiceEdit.periodicservicelink.house_comment
        this.periodicService.charged_in_curr_period = Number.parseFloat(this.periodicServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
        if (this.periodicServiceEdit.coefficientschedulelink) {
          this.periodicService.scheme_id = this.periodicServiceEdit.coefficientschedulelink.scheme_id
        }
      })
    } else {
      this.periodicService.policy_id = this.currentService.policy_id
      this.periodicService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  },
  computed: {
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.periodicService.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.periodicService.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    userHouse () {
      let userHouse = ''
      if (this.periodicService.house_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.periodicService.house_id) {
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            userHouse += '(' + el.house_id + ')'
            break
          }
        }
      }
      return userHouse
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formPeriodic.vue